import { useLocation, useNavigate } from "react-router-dom";
import { scrollToId } from "./scroll";

export const useGoTo = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  return (id) => {
    if (pathname === "/") scrollToId(id);
    else navigate("/", { state: { scrollTo: id } });
  };
};
